import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Chip from '../../Chip/Chip';
import { ChipsWrapper, ContentContainer, Container } from './Journey.styled';
import SubmissionsPage from '../Submissions';

const updateDocumentTitle = (currentSpaceName, chipDocumentTitlePrefix) => {
  const space = currentSpaceName ? `${currentSpaceName} - ` : '';
  document.title = `${chipDocumentTitlePrefix} - ${space}Aula`;
};

const renderSubmissions = () => (
  <Container>
    <SubmissionsPage />
  </Container>
);

const JourneyContent = React.memo(
  ({ chips, currentChipId, currentSpaceName, onChipChange, route }) => {
    const isSubmissionsPage = currentChipId === 'submissions';
    if (isSubmissionsPage) {
      return renderSubmissions();
    }

    const chipIndex = chips.findIndex((chip) => chip.id === currentChipId);
    if (chipIndex === -1) return null;

    const CurrentChipContent = chips[chipIndex].content;
    const chipDocumentTitlePrefix = chips[chipIndex].title;

    useEffect(() => {
      updateDocumentTitle(currentSpaceName, chipDocumentTitlePrefix);
    }, [currentSpaceName, chipDocumentTitlePrefix]);

    const handleChipChange = (chipId) => onChipChange(chipId);

    return (
      <Container>
        <ChipsWrapper>
          {chips.map((chip) => (
            <Chip
              key={chip.id}
              id={chip.id}
              title={chip.title}
              checked={chip.id === currentChipId}
              onChange={() => handleChipChange(chip.id)}
              aria-label={chip.title}
              data-testid={chip.id}
              aria-pressed={chip.id === currentChipId}
            />
          ))}
        </ChipsWrapper>
        <ContentContainer>
          <CurrentChipContent route={route} />
        </ContentContainer>
      </Container>
    );
  }
);

JourneyContent.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      content: PropTypes.func.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentChipId: PropTypes.string.isRequired,
  onChipChange: PropTypes.func.isRequired,
  currentSpaceName: PropTypes.string,
  route: PropTypes.shape({
    childRoutes: PropTypes.array,
    path: PropTypes.string,
  }).isRequired,
};

JourneyContent.defaultProps = {
  currentSpaceName: '',
};

export default JourneyContent;
